<template>
  <Transition name="dropdown">
    <div v-if="isOpen"
      class="absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-interactive-interactiveBg border border-border-line shadow-lg z-50"
      @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <div class="flex  " style="width: 32rem;">
        <!-- Products Column -->
        <div class="flex-1">
          <div>
            <!-- Grid Trade -->
            <a href="https://app.hyperliquid-testnet.xyz/trade"
              class="flex items-center gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
              <div class="flex-shrink-0">
              </div>
              <span class="block text-body2 text-t-primary">Testnet</span>
            </a>

            <!-- API Management -->
            <a href="https://app.hyperliquid.xyz/explorer"
              class="flex items-center gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
              <div class="flex-shrink-0">
              </div>
              <span class="block text-body2 text-t-primary">Explorer</span>
            </a>

            <!-- USDF -->
            <a href="https://app.hyperliquid.xyz/subAccounts"
              class="flex items-center gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
              <div class="flex-shrink-0">
              </div>
              <span class="block text-body2 text-t-primary">Sub-Accounts</span>
            </a>

            <!-- Earn -->
            <a href="https://app.hyperliquid.xyz/API"
              class="flex items-center gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
              <div class="flex-shrink-0">
              </div>
              <span class="block text-body2 text-t-primary">API</span>
            </a>

            <!-- Leaderboard -->
            <a href="https://app.hyperliquid.xyz/multiSig"
              class="flex items-center gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
              <div class="flex-shrink-0">
              </div>
              <span class="block text-body2 text-t-primary">Multi-Sig</span>
            </a>
          </div>
        </div>

        <!-- Resources Column -->
        <div class="flex-1">
          <div>
            <!-- What's New -->
            <a href="https://app.hyperliquid.xyz/announcements"
              class="flex items-center gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
              <div class="flex-shrink-0">
              </div>
              <span class="block text-body2 text-t-primary">Announcements</span>
            </a>

            <!-- Tutorial -->
            <a href="https://hyperscreener.asxn.xyz/home"
              class="flex items-center gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
              <div class="flex-shrink-0">
              </div>
              <span class="block text-body2 text-t-primary">Stats</span>
            </a>

            <!-- Dune -->
            <a href="/referral-program"
              class="flex items-center gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
              <div class="flex-shrink-0">
              </div>
              <span class="block text-body2 text-t-primary">Docs</span>
            </a>

            <!-- Feedback -->
            <a href="https://app.hyperliquid.xyz/points"
              class="flex items-center gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
              <div class="flex-shrink-0">
              </div>
              <span class="block text-body2 text-t-primary">Points</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'LandingPageMoreDropdown',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['mouseenter', 'mouseleave'],
  methods: {
    handleMouseEnter() {
      this.$emit('mouseenter')
    },
    handleMouseLeave() {
      this.$emit('mouseleave')
    }
  }
}
</script>

<style scoped>
/* Анимация появления dropdown */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.dropdown-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-enter-to,
.dropdown-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>

